import { FC } from 'react';
import { Button, Link } from '@/components/ui';
import { useTranslation } from '@/providers/app-provider/app-provider';
import { useStore } from '@/store/zustand/zustand.setup';

const CookieConsent: FC = () => {
  const { t } = useTranslation();
  const {
    general: { isCookiesAccepted },
    acceptCookies,
  } = useStore();

  if (isCookiesAccepted) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50">
      <div className="border-divider bg-primary shadow-small pointer-events-auto flex w-full items-center justify-between gap-x-20 border p-8">
        <p className="text-primary-foreground font-normal">
          {t?.common.cookieConsent.description.first}
          <Link className="text-primary-foreground mx-1 text-sm font-medium underline" href="#">
            {t?.common.cookieConsent.description.link}
          </Link>
          {t?.common.cookieConsent.description.second}
        </p>
        <div className="flex items-center gap-2">
          <Button
            onClick={acceptCookies}
            className="bg-primary-foreground text-primary font-medium"
            radius="lg"
          >
            {t?.common.cookieConsent.accept}
          </Button>
          <Button
            as="a"
            href="https://google.com"
            className="text-primary-foreground font-medium"
            radius="lg"
            variant="light"
          >
            {t?.common.cookieConsent.reject}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
